module.exports = __webpack_public_path__ + "img/Frame 81.e7851c4d.svg";